export interface DiffRow {
  left: string | null;
  right: string | null;
}

type LineOp = { kind: 'same' | 'remove' | 'add'; line: string };

function lineOps(before: string[], after: string[]): LineOp[] {
  const n = before.length;
  const m = after.length;
  const scores: number[][] = Array.from({ length: n + 1 }, () => Array<number>(m + 1).fill(0));
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      scores[i][j] = before[i] === after[j] ? scores[i + 1][j + 1] + 1 : Math.max(scores[i + 1][j], scores[i][j + 1]);
    }
  }
  const ops: LineOp[] = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (before[i] === after[j]) {
      ops.push({ kind: 'same', line: before[i] });
      i += 1;
      j += 1;
    } else if (scores[i + 1][j] >= scores[i][j + 1]) {
      ops.push({ kind: 'remove', line: before[i] });
      i += 1;
    } else {
      ops.push({ kind: 'add', line: after[j] });
      j += 1;
    }
  }
  while (i < n) {
    ops.push({ kind: 'remove', line: before[i] });
    i += 1;
  }
  while (j < m) {
    ops.push({ kind: 'add', line: after[j] });
    j += 1;
  }
  return ops;
}

export function splitDiff(before: string, after: string): DiffRow[] {
  const leftLines = before === '' ? [] : before.split('\n');
  const rightLines = after === '' ? [] : after.split('\n');
  const ops = lineOps(leftLines, rightLines);
  const rows: DiffRow[] = [];
  let index = 0;
  while (index < ops.length) {
    const op = ops[index];
    if (op.kind === 'same') {
      rows.push({ left: op.line, right: op.line });
      index += 1;
      continue;
    }
    const removed: string[] = [];
    const added: string[] = [];
    while (index < ops.length && ops[index].kind !== 'same') {
      if (ops[index].kind === 'remove') removed.push(ops[index].line);
      else added.push(ops[index].line);
      index += 1;
    }
    const count = Math.max(removed.length, added.length);
    for (let row = 0; row < count; row += 1) {
      rows.push({ left: removed[row] ?? null, right: added[row] ?? null });
    }
  }
  return rows;
}
